"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var DotsVerticalIcon = function DotsVerticalIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#333F48' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.0002 8.33325C9.0835 8.33325 8.3335 9.08325 8.3335 9.99992C8.3335 10.9166 9.0835 11.6666 10.0002 11.6666C10.9168 11.6666 11.6668 10.9166 11.6668 9.99992C11.6668 9.08325 10.9168 8.33325 10.0002 8.33325ZM10.0002 3.33325C9.0835 3.33325 8.3335 4.08325 8.3335 4.99992C8.3335 5.91658 9.0835 6.66658 10.0002 6.66658C10.9168 6.66658 11.6668 5.91658 11.6668 4.99992C11.6668 4.08325 10.9168 3.33325 10.0002 3.33325ZM10.0002 13.3333C9.0835 13.3333 8.3335 14.0833 8.3335 14.9999C8.3335 15.9166 9.0835 16.6666 10.0002 16.6666C10.9168 16.6666 11.6668 15.9166 11.6668 14.9999C11.6668 14.0833 10.9168 13.3333 10.0002 13.3333Z",
    fill: color
  }));
};
var _default = DotsVerticalIcon;
exports.default = _default;